import React from "react";

const BlogLayout = ({ children }) => {
  return <main className="flex flex-col">{children}</main>;
};

export default BlogLayout;
